import { useTranslate } from 'hooks/useTranslate';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';
import RecipientsTable from './RecipientsTable';

const CommunicationRecipientsSection = () => {
  const { t } = useTranslate();
  const { data, actions } = useCommunicationDetailsPage();

  const recipientsTotal = data.communication?.recipientsCount?.total ?? 0;
  const showPagination = recipientsTotal > 10;

  return (
    <div className="cm-recipients">
      <div className="cm-section-header">
        <h6 className="cm-section-header__title">{t('DeliveryStatus')}</h6>
        <Button
          className="cm-section-header__link"
          variant={ButtonVariants.LINK}
          icon="external"
          text={t('ViewCertificate')}
          onClick={actions.handleOpenCertification}
        />
      </div>

      <RecipientsTable isResumeTable />

      {showPagination && (
        <div className="cm-recipients__pagination">
          <TablePagination
            defaultPage={data.recipientsPage}
            totalRows={recipientsTotal}
            onChangePage={actions.handleChangeRecipientsPage}
            onChangeRowsPerPage={actions.handleChangeRecipientsRowsPerPage}
          />
        </div>
      )}
    </div>
  );
};

export default CommunicationRecipientsSection;
